
<div class="login-container" *ngIf="!cadastroAtivo">
	<div class="login-box" style="width: 380px;">
			<img style="width: 100%;" *ngIf="AppConfig.theme == 'light'" alt="Talk" src="image/talklogomedium_{{logo}}.png"
				alt="Logo">
				<div *ngIf="!loadCompleto" style="text-align: center; padding: 20px;" >
					<mat-icon style="font-size: 150px; width: 150px;" color="primary"> 
						queue_play_next
					</mat-icon>
				</div>
				<div class="container" *ngIf="erro == null && loadCompleto">
					<h1>{{'telaIntegracaoCadastro.tituloSucesso'|translate}}</h1>
					<p>{{'telaIntegracaoCadastro.mensagemSucesso1'|translate}}</p>
					<p>{{'telaIntegracaoCadastro.mensagemSucesso2'|translate}}</p>
					<p>{{'telaIntegracaoCadastro.mensagemSucesso3'|translate}} <a href="login">{{'telaIntegracaoCadastro.cliqueAqui'|translate}}</a>.</p>
				</div>
				<div  *ngIf="erro != null && loadCompleto">
					<h2>{{'telaIntegracaoCadastro.tituloErro'|translate}}</h2>
        				<p>{{'telaIntegracaoCadastro.mensagemErro1'|translate}}</p>
        				<p style="color: brown;">	<b>{{erro|translate}}</b> </p>
        				<a  href="loginl">{{'telaIntegracaoCadastro.mensagemErro2'|translate}}</a>
				</div>
	</div>
</div>
<div *ngIf="loadCompleto && cadastroAtivo" class="formCadastro">
	<app-elasticsearch-edit-form 
		[dados]="dados" 
		[lista]="lista"
		[listaId]="listaId"
		[isEdit]="isEdit"
		[cadastroIntegracao]="cadastroIntegracao"
		[template]="template"
		(eventFechar)="fechar($event)"
		[tokenCadastroIntegracao]="token">
	</app-elasticsearch-edit-form>
</div>